<div class="insights-welcome container-lg">
  <div *ngIf="isLoading" class="text-center py-5">
    <i class="fa fa-spinner fa-spin fa-3x" aria-hidden="true"></i>
  </div>

  <div *ngIf="!isLoading"
       class="row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-3"
       [ngClass]="dashboards.length <= 3 ? 'justify-content-center' : 'justify-content-start'">
    <div class="col" *ngFor="let dashboard of dashboards">
      <div class="dashboard-card h-100">
        <div
          class="dashboard-card__thumbnail"
          [class.clickable]="dashboard.hasAccess && dashboard.photo"
          [class.locked]="!dashboard.hasAccess"
          (click)="dashboard.hasAccess && dashboard.photo && onOpen(dashboard)">
          <img
            *ngIf="dashboard.photo"
            [src]="insightsService.getDashboardPhotoUrl(dashboard.photo)"
            [alt]="dashboard.name"
            class="dashboard-card__img"
          />
          <div *ngIf="!dashboard.photo" class="dashboard-card__img-placeholder">
            <i class="fa fa-bar-chart fa-3x" aria-hidden="true"></i>
          </div>
        </div>

        <div class="dashboard-card__body">
          <p class="dashboard-card__title">{{ dashboard.name }}</p>
          <p class="dashboard-card__description">{{ dashboard.description }}</p>
        </div>

        <div class="dashboard-card__footer">
          <button
            *ngIf="dashboard.hasAccess"
            type="button"
            class="btn btn-primary w-100"
            (click)="onOpen(dashboard)">
            OPEN
          </button>
          <button
            *ngIf="!dashboard.hasAccess"
            type="button"
            class="btn btn-outline-primary w-100"
            (click)="onRequestAccess(dashboard)">
            REQUEST ACCESS
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
